import { render, staticRenderFns } from "./Author.vue?vue&type=template&id=4d3b832b&scoped=true&"
import script from "./Author.vue?vue&type=script&lang=js&"
export * from "./Author.vue?vue&type=script&lang=js&"
import style0 from "./Author.vue?vue&type=style&index=0&id=4d3b832b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3b832b",
  null
  
)

export default component.exports